(function(){
  var CSS = '.vbr-gallery{position:relative}'+
    '.vbr-gallery__track{touch-action:pan-x pan-y;-webkit-overflow-scrolling:touch;cursor:grab;user-select:none}'+
    '.vbr-gallery__track.is-drag{cursor:grabbing;scroll-snap-type:none}'+
    '.vbr-gallery__track img{pointer-events:none;-webkit-user-drag:none}'+
    '.vbr-arrow{position:absolute;top:0;margin-top:calc(50% - 22px);width:44px;height:44px;border-radius:99px;border:0;background:rgba(255,255,255,.92);color:#1A1917;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.12);z-index:2;padding:0;transition:opacity .2s}'+
    '.vbr-arrow[disabled]{opacity:0;pointer-events:none}'+
    '.vbr-arrow--prev{left:12px}.vbr-arrow--next{right:12px}'+
    '.vbr-arrow svg{width:18px;height:18px}'+
    '.vbr-dots span{cursor:pointer;padding:0}'+
    '.vbr-dots{pointer-events:auto}';
  function addCss(){
    if(document.getElementById('vbr-gallery-css'))return;
    var s=document.createElement('style');s.id='vbr-gallery-css';s.textContent=CSS;document.head.appendChild(s);
  }
  var chev=function(d){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="'+(d<0?'M15 5l-7 7 7 7':'M9 5l7 7-7 7')+'"/></svg>'};
  function initGallery(root){
    var gal=root.querySelector('.vbr-gallery');var track=root.querySelector('[data-vbr-track]');
    if(!gal||!track)return;
    var slides=track.children;var n=slides.length;if(n<2)return;
    var dots=root.querySelectorAll('[data-vbr-dot]');
    var gap=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||10;
    var w=function(){return track.clientWidth+gap};
    var idx=function(){return Math.max(0,Math.min(n-1,Math.round(track.scrollLeft/w())))};
    var go=function(i){i=Math.max(0,Math.min(n-1,i));track.scrollTo({left:i*w(),behavior:'smooth'})};
    var prev=document.createElement('button');prev.type='button';prev.className='vbr-arrow vbr-arrow--prev';prev.setAttribute('aria-label','F\u00f6reg\u00e5ende bild');prev.innerHTML=chev(-1);
    var next=document.createElement('button');next.type='button';next.className='vbr-arrow vbr-arrow--next';next.setAttribute('aria-label','N\u00e4sta bild');next.innerHTML=chev(1);
    gal.appendChild(prev);gal.appendChild(next);
    prev.addEventListener('click',function(){go(idx()-1)});
    next.addEventListener('click',function(){go(idx()+1)});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j)})});
    var dotsWrap=root.querySelector('.vbr-dots');if(dotsWrap)dotsWrap.removeAttribute('aria-hidden');
    var update=function(){var i=idx();dots.forEach(function(d,j){d.setAttribute('aria-current',j===i?'true':'false')});prev.disabled=i===0;next.disabled=i===n-1;};
    track.addEventListener('scroll',update,{passive:true});update();
    var down=false,sx=0,sl=0,moved=false;
    track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;sx=e.clientX;sl=track.scrollLeft;track.classList.add('is-drag');});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4)moved=true;track.scrollLeft=sl-dx;});
    window.addEventListener('pointerup',function(e){if(!down)return;down=false;track.classList.remove('is-drag');var dx=e.clientX-sx;var i=Math.round(sl/w());if(dx<-40)i++;else if(dx>40)i--;go(i);});
    track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
    track.setAttribute('tabindex','0');
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(idx()+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(idx()-1)}});
    window.addEventListener('resize',function(){track.scrollLeft=idx()*w()});
  }
  function initSticky(root){
    var bar=document.querySelector('[data-vbr-sticky="'+root.dataset.sectionId+'"]');var anchor=root.querySelector('[data-vbr-anchor]');
    if(!bar||!anchor||!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(entries){var e=entries[0];bar.dataset.visible=(!e.isIntersecting&&e.boundingClientRect.top<0)?'true':'false';}).observe(anchor);
  }
  function init(){
    addCss();
    document.querySelectorAll('[data-vbr-main]').forEach(function(root){
      if(root.dataset.vbrReady)return;root.dataset.vbrReady='1';
      initGallery(root);initSticky(root);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
